import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { BsFillReplyAllFill, BsDash } from "react-icons/bs";
import { FiChevronUp } from "react-icons/fi";
import { sohag, careerDevelopmentBg } from "../../assets";
import TopBanner from "../../components/designTab/TopBanner";
import CoursesIntro from "../../components/pageProps/CoursesIntro";
import Bonus from "../../components/pageProps/Bonus";

const CareerDevelopment = () => {
  // ================ Course Module start here ==================
  const [showCourseMaterials, setShowCourseMaterials] = useState(true);
  const [showCourseFacilities, setShowCourseFacilities] = useState(false);
  // ================ Course Module end here ====================
  return (
    <div className="w-full h-auto">
      <Helmet>
        <title>Career Development - EduCare English Learning Academy</title>
      </Helmet>
      <TopBanner titleText="Career Development" />
      <div className="max-w-screen-xl mx-auto pb-4 pt-2 px-4 flex flex-col lgl:flex-row items-start xl:gap-10 justify-between">
        <div className="w-full flex flex-col gap-4 md:gap-10">
          <CoursesIntro
            intro="Welcome to Our Course "
            des="Welcome to our Professional Development Course, designed to equip fresh graduates with the necessary skills and knowledge to succeed in the job market. Our comprehensive curriculum covers Job Skills Training, Business Communication Skills, and other essential aspects of Professional Development. By enrolling in our course, you will gain a competitive edge in your job search and learn the tips and tricks to stand out from the crowd. Enroll today to initiate your journey toward accomplishing your career aspirations.."
            instructorName="Sohag Khan"
            instructorTitle="Chief Advisor, Corporate Trainer"
            instructorImg={sohag}
            classTitle="Total Class"
            classNo="15"
            langClubTitle="Examination"
            debate="Internship"
            supportTitle="CV Writing"
            bg={careerDevelopmentBg}
          />
          {/* =====================================================
                        Course overview start here
           ===================================================== */}
          <div>
            <h3 className="font-titleFont text-xl md:text-2xl font-semibold mb-1 md:mb-4">
              Why Career Development course is for you?
            </h3>
            <div className="w-full border hover:shadow-lg transition-hover duration-300 border-primeColor rounded-md border-opacity-30 p-4 flex justify-start items-center gap-4">
              <div>
                <p className="text-[16px] font-bodyFont tracking-wide text-gray-600">
                  An employer always asks 04 questions to select a candidate in
                  an interview board :
                </p>
                <ul className="flex flex-col mt-2 gap-1 font-bodyFont text-gray-700">
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    How much do I pay?
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    How much do I get back?
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    How soon I will get back?
                  </li>
                  <li className="courseModuleListli">
                    <span className="listliSpan">
                      <BsFillReplyAllFill />
                    </span>
                    How I can be sure that you are the right guy?
                  </li>
                </ul>
                <p className="text-base text-gray-700 font-bodyFont tracking-normal mt-1">
                  If you can answer these 04 questions to an employer, you will
                  get hired for sure. Unfortunately, sometimes the recruiters
                  don't ask these questions directly and sometimes they don't
                  ask these questions at all!!! So it's the responsibility of
                  the candidates to answer them indirectly through storytelling.
                  HERE IS THE CLICK, because the candidates don't know what to
                  say, even if they don't know what they don't know. So I am MS
                  Khan with my long corporate experience, served 32+ companies
                  with my advisory, worked as CEO, COO, GM, Director, Chief
                  Advisor, Head of Sales/ Marketing/ Business Development/
                  Operation/ Growth Analyst/ Sales Analyst/ Motivational
                  Speaker, experienced with 11,000+ interviews taken, 7100+
                  employee training with 165+ sessions on 143+ powerful training
                  modules, offering you “ROAD TO CORPORATE - THE JOURNEY TO GET
                  THE BEST JOB WITHIN RECORD TIME”. I have made this course
                  purely based on my experience & I am completely aware of WHY
                  PEOPLE FAIL IN THE INTERVIEW BOARD. Through these powerful
                  Corporate Classes, candidates will become well-organized
                  before they are entering for a live interview session. Through
                  these Corporate Sessions, undergraduates/ graduates/ post
                  graduates will act like Super-Fast, they will achieve
                  unbelievable performance not only to get the job but also to
                  achieve HOW TO GET THE PLANNED PROMOTION & you will achieve
                  your growth double.
                </p>
              </div>
            </div>
          </div>

          {/* =====================================================
                        Course overview end here
           ===================================================== */}
          {/* =====================================================
                        Course MODULE start here
           ===================================================== */}

          <h3 className="font-titleFont text-xl md:text-2xl font-semibold -mb-4">
            Course Modules
          </h3>
          <div className="w-full border hover:shadow-lg transition-hover duration-200 border-primeColor rounded-md border-opacity-30 p-4">
            {/* =================== Course materials Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseMaterials(!showCourseMaterials)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course materials :
                {showCourseMaterials ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseMaterials && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Answer 04 questions & get hired.
                      </li>
                      <li className="flex gap-2 items-start">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        How to make THE BEST PROPOSAL - resume writing?
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        How to get more interview calls?
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Prepare yourself for THE BATTLE OF INTERVIEW.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Let the recruiter say "YES" or "YES".
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Reason for selecting & not selecting.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Crucial TRICKS TO CONVINCE ANY RECRUITER.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
            {/* =================== Course Facilities Start here ============== */}
            <div>
              <h3
                onClick={() => setShowCourseFacilities(!showCourseFacilities)}
                className="font-titleFont text-lg md:text-xl cursor-pointer font-semibold flex justify-between items-center"
              >
                Course Facilities :
                {showCourseFacilities ? (
                  <span className="text-2xl text-primeColor rotate-0 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                ) : (
                  <span className="text-2xl text-primeColor rotate-180 transition-rotate duration-300">
                    <FiChevronUp />
                  </span>
                )}
              </h3>
              {showCourseFacilities && (
                <>
                  <div className="w-full flex justify-start items-center">
                    <ul className="ulListModule">
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        16 online classes.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        24.00 hours of total course duration.
                      </li>
                      <li className="flex gap-2 items-start">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        80+ mock interview sessions.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        200+ professional resume templates.
                      </li>
                      <li className="flex gap-2 items-start">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        4000+ company job sources.
                      </li>
                      <li className="courseModuleListli">
                        <span className="courseModuleListliSpan">
                          <BsDash />
                        </span>
                        Certifications.
                      </li>
                    </ul>
                  </div>
                </>
              )}
              <hr className="h-[1px] bg-darkPink mt-2 mb-2" />
            </div>
          </div>
          <div>
            <Bonus
              bonus="How to achieve Planned Promotion."
              awards="Based on your performance, you will be awarded. Also, we will provide you with the certificate after completing the course."
            />
          </div>
          {/* =====================================================
                        Course MODULE end here
           ===================================================== */}
        </div>
      </div>
    </div>
  );
};

export default CareerDevelopment;
